import {
  Avatar as HeroUIAvatar,
  AvatarProps as HeroUIAvatarProps,
} from "@heroui/react";

export function Avatar({ ...props }: HeroUIAvatarProps) {
  return <HeroUIAvatar {...props} />;
}

Avatar.displayName = "RecareUI.Avatar";
